import ls from "localstorage-slim";
import type { CloudFlareResponse } from "~/types/cloudFlare";

/*
// cfRequest response
{
  "ip": "159.196.179.89",
  "colo": "MEL",
  "country": "AU",
  "city": "Melbourne",
  "continent": "OC",
  "latitude": "-37.81590",
  "longitude": "144.96690",
  "region": "Victoria",
  "regionCode": "VIC",
  "timezone": "Australia/Melbourne",
  "asn": 4764,
  "asOrganization": "Aussie Broadband"
}
*/

export function useCfRequest() {
  const config = useRuntimeConfig();
  const DEBUG = config.public.appEnv === "local";
  const storageKey = "_abbcf_";
  const ttl = 3600;
  const cf: CloudFlareResponse | null = ls.get(storageKey, { decrypt: true });

  if (cf) {
    if (DEBUG) console.log("CloudFlare Request", cf);
    return cf;
  }
  return $fetch("/api/cf/")
    .then((response) => {
      ls.set(storageKey, response, { encrypt: true, ttl: ttl });
      if (DEBUG) console.log("CloudFlare Request", response);
      return response as CloudFlareResponse;
    })
    .catch((error) => {
      if (DEBUG) console.log("CloudFlare Error", error);
      return;
    });
}
